import React, { useEffect, useRef, useState } from 'react';
import classnames from "classnames";
import { UncontrolledCollapse, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

function CustomCollapse({ icon, name, children, toggler, isCollapsed, setIsCollapsed, className = "", btn, canEdit, onRemove, onDuplicate, onChange }) {
  
  function handleFocus(e) {
    e.target.classList.add('focus');
  }

  function handleBlur(e) {
    e.target.classList.remove('focus');
  }

  return (
    <li className='accordion-item'>
      <h2 className='d-flex align-items-center justify-content-between accordion-header'>
        <button
          className={classnames(`accordion-button ${className}`, { collapsed: isCollapsed })}
          type='button'
          style={{ cursor: "move" }}
        >
          <div className='d-flex flex-fill align-items-center flex-nowrap' style={{maxWidth: 'calc(100% - 65px)'}}>
            {icon}
            {isCollapsed ? 
            <p className='m-0 user-select-none'>{name}</p>
            : 
            <span className='field-edit-name' style={{minWidth: '50px', direction: 'ltr'}} editable={true} contentEditable={true} onFocus={handleFocus} onBlur={handleBlur} onInput={onChange}>{name}</span>
            }
          </div>
          <div className='d-flex gap-1'>
            <button className='btn btn-icon btn-sm edit text-muted' id={toggler} onClick={() => setIsCollapsed(!isCollapsed)}
              style={{ cursor: "pointer" }}
            >
              <i className='ri-pencil-fill fs-16 align-middle'></i>
            </button>
            {canEdit ?
              <UncontrolledDropdown>
                <DropdownToggle tag="button" className={`btn btn-sm ${btn}`}>
                  <i className="ri-more-fill align-middle"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={onDuplicate}>
                    <i className='mdi mdi-card-multiple-outline align-bottom me-1'></i> Duplicate
                  </DropdownItem>
                  <DropdownItem onClick={onRemove}>
                    <i className='ri-delete-bin-2-line align-bottom me-1'></i> Remove
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            : null}
            
          </div>
        </button>
      </h2>
      <UncontrolledCollapse toggler={'#' + toggler} className='accordion-collapse'>
        <div className='accordion-body'>
          {children}
        </div>
      </UncontrolledCollapse>
    </li>
  )
}

export default CustomCollapse;
